// @ts-nocheck
import React from "react";
import moment from "moment";
import useAccount from "classes/Accounts/hooks/useAccount";
import formatDate from "includes/formatDate";
import genRequest from "includes/request";
import { t } from "i18next";
import FormsTableToolbar from "./FormsTableToolbar";
import { AsyncTable } from "components/Table/Table";

export default function FormsTable(props) {
	const { account, isAdmin } = useAccount();
	const { search, onClick, className } = props;
	let date = formatDate();
	let drafts = props.showDrafts || false;

	const filterFunction = (data) => {
		return data.filter((a) => {
			if (props.hideSelected && props.selected) {
				if (props.selected.findIndex((f) => f.id === a.id) > -1)
					return (false);
			}
			if (drafts !== a.isDraft)
				return (false);
			if (
				((!a.availableToDate || a.availableToDate >= date) && (a.publishedDate <= date))
				|| isAdmin()
			)
				return (a);
			return (false);
		});
	};

	return (
		<div className="FormsTable">
			<AsyncTable
				companyId={account.companyId}
				rowIdKey={"id"}
				queryKey={["Forms", "FormAffectedToCompany", account.companyId, "Drafts=" + drafts]}
				queryFn={() => genRequest("forms/company/" + account.companyId)}
				options={{
					selection: isAdmin()
				}}
				search={search}
				onRowClick={(e, row) => onClick?.(row)}
				className={className}
				columns={[
					{
						field: "title",
						title: t("Table.TITLE")
					},
					{
						field: "txt",
						title: t("Table.DESC"),
						className: "form-desc-cell"
					},
					{
						title: t("Table.PUBLISHED_DATE"),
						field: "publishedDate",
						render: (data) => <DateCell item={data} publishedDate={true} />,
						defaultSort: "desc"
					},
					{
						title: t("Table.AVAILABLE_TO_DATE"),
						field: "availableTo",
						render: (data) => <DateCell item={data} availableTo={true} />
					}
				]}
				overloads={{
					Toolbar: props.toolbar !== false ?
						(cprops, options) => (
							<FormsTableToolbar
								canDelete={props.canDelete}
								{...cprops}
								{...options}
							/>
						)
						: () => false
				}}
				filter={filterFunction}
				onSelectionChange={props.onSelectionChange}
			/>
		</div>
	);
}

function DateCell(props) {
	const { item } = props;
	let date = formatDate();

	if (props.availableTo && !item.availableToDate)
		return (false);
	return (
		<div className="d-flex align-items-center">
			{
				item.priorityTo >= date &&
				<div className="me-1" title={t("Forms.AVAILABLE_TO_DATE", { date: formatDate(item.availableToDate, t("Commons.CUSTOM_FORMAT_DATE")) })}>
					<div className="dot priority-dot" />
				</div>
			}
			{moment(props.publishedDate ? item.publishedDate : item.availableToDate).format(t("Events.TILE_DATE_FORMAT"))}
		</div>
	);
}
